/** Finish types for FLUX lab custom tab — same lists as makeup category configs. */

import blushConfig from '../../makeuphair/components/services/configs/makeup/blush';
import contourConfig from '../../makeuphair/components/services/configs/makeup/contour';
import eyeshadowConfig from '../../makeuphair/components/services/configs/makeup/eyeshadow';
import highlighterConfig from '../../makeuphair/components/services/configs/makeup/highlighter';
import lipstickConfig from '../../makeuphair/components/services/configs/makeup/lipstick';

const FOUNDATION_FINISHES = [
  { id: 'sheer', name: 'Sheer' },
  { id: 'satin', name: 'Satin' },
  { id: 'matte', name: 'Matte' },
  { id: 'dewy', name: 'Dewy' },
];

const FINISH_ALIASES = {
  gloss: 'glossy',
  glossy: 'glossy',
};

function mapFinishTypes(finishTypes) {
  if (!Array.isArray(finishTypes) || !finishTypes.length) return [];
  return finishTypes.map((f) => ({ id: String(f.id), name: String(f.name || f.id) }));
}

function finishesForCategory(category) {
  switch (category) {
    case 'foundation':
      return FOUNDATION_FINISHES;
    case 'blush':
      return mapFinishTypes(blushConfig.finishTypes);
    case 'eyeshadow':
      return mapFinishTypes(eyeshadowConfig.finishTypes);
    case 'lipstick':
      return mapFinishTypes(lipstickConfig.finishTypes);
    case 'highlighter':
      return mapFinishTypes(highlighterConfig.finishTypes);
    case 'contour':
      return mapFinishTypes(contourConfig.finishTypes);
    default:
      return [];
  }
}

export const FLUX_LAB_FINISH_CATEGORIES = [
  'foundation',
  'blush',
  'eyeshadow',
  'lipstick',
  'highlighter',
  'contour',
];

export const FLUX_LAB_FINISH_OPTIONS = Object.fromEntries(
  FLUX_LAB_FINISH_CATEGORIES.map((cat) => [cat, finishesForCategory(cat)]),
);

function normalizeFinishId(finishId, category) {
  const id = String(finishId || '').toLowerCase();
  const aliased = FINISH_ALIASES[id] || id;
  const list = FLUX_LAB_FINISH_OPTIONS[category] || [];
  if (list.some((f) => f.id === aliased)) return aliased;
  if (list.some((f) => f.id === id)) return id;
  return aliased;
}

export function applyFinishToLayer(layer, finishId, category) {
  if (!layer || typeof layer !== 'object') return layer;
  const list = FLUX_LAB_FINISH_OPTIONS[category] || [];
  const norm = normalizeFinishId(finishId, category);
  const hit = list.find((f) => f.id === norm) || list[0];
  if (!hit) return layer;
  return { ...layer, finishType: hit.id, finishName: hit.name };
}

/** Resolve select value when layer uses legacy ids (e.g. gloss vs glossy). */
export function finishSelectValue(layer, category) {
  const list = FLUX_LAB_FINISH_OPTIONS[category] || [];
  if (!list.length) return '';
  const raw = layer?.finishType;
  if (!raw) return list[0].id;
  const norm = normalizeFinishId(raw, category);
  return list.some((f) => f.id === norm) ? norm : list[0].id;
}
